import React from 'react';

import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';

import useThemeModePreference, { THEME_MODES } from '~/hooks/useThemeModePreference';

interface ThemeModeMenuItemProps {
  onClick?: () => void;
}

export default function ThemeModeMenuItem({ onClick }: ThemeModeMenuItemProps) {
  const { themeMode, setThemeMode } = useThemeModePreference();
  const isDarkModeEnabled = themeMode === THEME_MODES.DARK;

  const handleClick = () => {
    setThemeMode(isDarkModeEnabled ? THEME_MODES.LIGHT : THEME_MODES.DARK);
    onClick?.();
  };

  return (
    <MenuItem onClick={handleClick}>
      <ListItemIcon>{isDarkModeEnabled ? <LightModeIcon /> : <DarkModeIcon />}</ListItemIcon>
      <ListItemText>{isDarkModeEnabled ? 'Use light mode' : 'Use dark mode'}</ListItemText>
    </MenuItem>
  );
}
